import { useMutation } from '@tanstack/react-query';
import { showToast } from '@repo/ui';
import { feedbackApi } from '../api/feedbackApi';
import type { CreateFeedbackRequest } from '../types';

/**
 * Mutation hook for submitting feedback
 */
export function useSubmitFeedback() {
  return useMutation({
    mutationFn: async (data: CreateFeedbackRequest) => {
      return await feedbackApi.submitFeedback(data);
    },
    onSuccess: () => {
      showToast.success('Thank you for your feedback! We will review it shortly.');
    },
    onError: (error: any) => {
      showToast.error(
        error?.response?.data?.message || error?.message || 'Failed to submit feedback. Please try again.'
      );
    },
  });
}

